import { StyleSheet } from "react-native";

export const sharedStyles = StyleSheet.create({
  container: {
    padding: 0,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
  },
  content: {
    marginTop: 16,
  },
  flagsList: {
    marginTop: 8,
  },
  fullWidthButton: {
    flex: 1,
    alignSelf: "stretch",
  },
});
